/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Referral_Step2_SubInputs */

const tr_landing_referral_step2_sub = /** @type {(inputs: Landing_Referral_Step2_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Davet kodu otomatik uygulanır; ilk ayında indirim hazır.`)
};

const en_landing_referral_step2_sub = /** @type {(inputs: Landing_Referral_Step2_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The invite code applies automatically; their first-month discount is ready.`)
};

const de_landing_referral_step2_sub = /** @type {(inputs: Landing_Referral_Step2_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Einladungscode wird automatisch angewendet; der Rabatt für den ersten Monat steht bereit.`)
};

const ru_landing_referral_step2_sub = /** @type {(inputs: Landing_Referral_Step2_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Код приглашения применяется автоматически; скидка на первый месяц уже готова.`)
};

/**
* | output |
* | --- |
* | "The invite code applies automatically; their first-month discount is ready." |
*
* @param {Landing_Referral_Step2_SubInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_referral_step2_sub = /** @type {((inputs?: Landing_Referral_Step2_SubInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Referral_Step2_SubInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_referral_step2_sub(inputs)
	if (locale === "de") return de_landing_referral_step2_sub(inputs)
	if (locale === "ru") return ru_landing_referral_step2_sub(inputs)
	return tr_landing_referral_step2_sub(inputs)
});